// Libs
import { Action } from 'redux/types/Action';
// App
import { BagSliceState, ExistingProductAction, AddProductAction, Product } from './bag.slice.interfaces';
import { addNewProduct, addNewOrder, findProductExactMatch } from './bag.slice.utils';
import { ORDER_TYPE } from 'app-shared/lib/api/shared/order.interfaces';

export const reducers = {
  // Product

  addProduct: (state: BagSliceState, action: Action<AddProductAction>): void => {
    const { product, shop, selectedOptions, isAiSuggestion } = action.payload;

    if (!state.createdDate) {
      state.createdDate = new Date();
    }

    if (!state.order) {
      state.order = addNewOrder(shop);
    }

    let bagProduct = findProductExactMatch(state, product, selectedOptions);

    if (!bagProduct) {
      bagProduct = addNewProduct(state.order, product, selectedOptions, isAiSuggestion);
    }

    increaseQuantity(bagProduct);
  },

  removeProduct: (state: BagSliceState, action: Action<ExistingProductAction>): void => {
    const { productIndex } = action.payload;

    state.order.products.splice(productIndex, 1);

    if (!state.order.products.length) {
      state.order = null;
    }
  },

  increaseProductQuantity: (state: BagSliceState, action: Action<ExistingProductAction>): void => {
    const { productIndex } = action.payload;
    const product = state.order.products[productIndex];

    increaseQuantity(product);
  },

  decreaseProductQuantity: (state: BagSliceState, action: Action<ExistingProductAction>): void => {
    const { productIndex } = action.payload;
    const product = state.order.products[productIndex];

    decreaseQuantity(product);
  },

  setMeetingDateForOrder: (
    state: BagSliceState,
    action: Action<{ meetingStartDate: Date; meetingEndDate: Date }>
  ): void => {
    const { meetingStartDate, meetingEndDate } = action.payload;

    state.order.receptionMeetingStartDate = meetingStartDate;
    state.order.receptionMeetingEndDate = meetingEndDate;
  },

  // Order

  setTypeForOrder: (state: BagSliceState, action: Action<{ type: ORDER_TYPE }>): void => {
    const { type } = action.payload;

    state.order.type = type;
  },

  setUserSelectedSuggestedProducts: (state: BagSliceState): void => {
    state.order.hasUserSelectedSuggestedProducts = true;
  },

  // Clear

  emptyAll: (state: BagSliceState): void => {
    state.order = null;
    state.createdDate = null;
  },
};

const increaseQuantity = (item: Product) => {
  const hasMinQuantity = item.minQuantity != null;
  const isQuantityUnderMin = hasMinQuantity && item.quantity < item.minQuantity;
  const hasMaxQuantity = item.maxQuantity != null;
  const isQuantityUpperOrEqualMax = hasMaxQuantity && item.quantity >= item.maxQuantity;

  if (isQuantityUnderMin) {
    item.quantity = item.minQuantity;

    return;
  }

  if (isQuantityUpperOrEqualMax) return;

  item.quantity++;
};

const decreaseQuantity = (item: Product) => {
  const hasMinQuantity = item.minQuantity != null;
  const isMinQuantity = (hasMinQuantity && item.quantity < item.minQuantity) || item.quantity == 0;

  if (isMinQuantity) return;

  item.quantity--;
};
